import { normalizeCosmetics, num, str } from "./normalize";

export type Emit = (e: unknown) => void;
export type TrackSeq = (d: Record<string, unknown>) => boolean;

export function handleUpgradePurchased(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "upgrade_purchased",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    upgradeId: typeof d["upgradeId"] === "string" ? (d["upgradeId"] as string) : typeof d["id"] === "string" ? (d["id"] as string) : "",
    level: num(d["level"], 0),
    autoLevel: num(d["autoLevel"], 0),
    cps: str(d["cps"], "0"),
    clickPower: typeof d["clickPower"] === "string" ? (d["clickPower"] as string) : typeof d["click_power"] === "string" ? (d["click_power"] as string) : undefined,
    credits: typeof d["credits"] === "string" ? (d["credits"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  });
}

export function handleModuleUpgraded(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "module_upgraded",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    moduleId: typeof d["moduleId"] === "string" ? (d["moduleId"] as string) : typeof d["id"] === "string" ? (d["id"] as string) : "",
    level: num(d["level"], 0),
    cps: str(d["cps"], "0"),
    cookies: typeof d["cookies"] === "string" ? (d["cookies"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  } as unknown as never);
}

export function handleProjectCompleted(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "project_completed",
    seq: num(d["seq"], lastSeq),
    projectId: typeof d["projectId"] === "string" ? (d["projectId"] as string) : typeof d["id"] === "string" ? (d["id"] as string) : "",
    cpsBonus: str(d["cpsBonus"], "0"),
    cookies: typeof d["cookies"] === "string" ? (d["cookies"] as string) : undefined,
    cps: typeof d["cps"] === "string" ? (d["cps"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  } as unknown as never);
}

export function handleProjectStarted(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "project_started",
    seq: num(d["seq"], lastSeq),
    projectId: typeof d["projectId"] === "string" ? (d["projectId"] as string) : typeof d["id"] === "string" ? (d["id"] as string) : "",
    startedAt: typeof d["startedAt"] === "number" && Number.isFinite(d["startedAt"] as number) ? (d["startedAt"] as number) : Date.now(),
    endsAt: typeof d["endsAt"] === "number" && Number.isFinite(d["endsAt"] as number) ? (d["endsAt"] as number) : Date.now(),
    durationMs: typeof d["durationMs"] === "number" && Number.isFinite(d["durationMs"] as number) ? (d["durationMs"] as number) : 0,
    cookies: typeof d["cookies"] === "string" ? (d["cookies"] as string) : undefined,
    cps: typeof d["cps"] === "string" ? (d["cps"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  } as unknown as never);
}

export function handleAbilityActivated(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "ability_activated",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    abilityId: typeof d["abilityId"] === "string" ? (d["abilityId"] as string) : "",
    cost: typeof d["cost"] === "string" ? (d["cost"] as string) : undefined,
    credits: typeof d["credits"] === "string" ? (d["credits"] as string) : undefined,
    cooldownMs: typeof d["cooldownMs"] === "number" && Number.isFinite(d["cooldownMs"] as number) ? (d["cooldownMs"] as number) : undefined,
    cooldownRemainingMs: typeof d["cooldownRemainingMs"] === "number" && Number.isFinite(d["cooldownRemainingMs"] as number) ? (d["cooldownRemainingMs"] as number) : undefined,
    endsAt: typeof d["endsAt"] === "number" && Number.isFinite(d["endsAt"] as number) ? (d["endsAt"] as number) : undefined,
    durationMs: typeof d["durationMs"] === "number" && Number.isFinite(d["durationMs"] as number) ? (d["durationMs"] as number) : undefined,
    amount: typeof d["amount"] === "string" ? (d["amount"] as string) : undefined,
    creditsGained: typeof d["creditsGained"] === "string" ? (d["creditsGained"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  } as unknown as never);
}

export function handleQuestClaimed(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "quest_claimed",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    questId: typeof d["questId"] === "string" ? (d["questId"] as string) : "",
    reward: num(d["reward"], 0),
    credits: typeof d["credits"] === "string" ? (d["credits"] as string) : undefined,
  } as unknown as never);
}

export function handleCosmeticPurchased(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  emit({
    type: "cosmetic_purchased",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    cosmeticId: typeof d["cosmeticId"] === "string" ? (d["cosmeticId"] as string) : "",
    slot: typeof d["slot"] === "string" ? (d["slot"] as string) : "",
    cost: typeof d["cost"] === "string" ? (d["cost"] as string) : undefined,
    currency: typeof d["currency"] === "string" ? (d["currency"] as string) : undefined,
    credits: typeof d["credits"] === "string" ? (d["credits"] as string) : undefined,
    bakeryCookies: typeof d["bakeryCookies"] === "string" ? (d["bakeryCookies"] as string) : undefined,
    bakeryCps: typeof d["bakeryCps"] === "string" ? (d["bakeryCps"] as string) : undefined,
    bakeryLifetimeCookies: typeof d["bakeryLifetimeCookies"] === "string" ? (d["bakeryLifetimeCookies"] as string) : undefined,
    bakeryLevel: typeof d["bakeryLevel"] === "number" && Number.isFinite(d["bakeryLevel"] as number) ? (d["bakeryLevel"] as number) : undefined,
    bakeryNextLevelCookies: typeof d["bakeryNextLevelCookies"] === "string" ? (d["bakeryNextLevelCookies"] as string) : undefined,
    bakeryLevelProgress: typeof d["bakeryLevelProgress"] === "number" && Number.isFinite(d["bakeryLevelProgress"] as number) ? (d["bakeryLevelProgress"] as number) : undefined,
  } as unknown as never);
}

export function handleCosmeticEquipped(d: Record<string, unknown>, emit: Emit, trackSeq: TrackSeq, lastSeq: number): void {
  if (!trackSeq(d)) return;
  const eq = d["equipped"] && typeof d["equipped"] === "object" ? normalizeCosmetics(d["equipped"] as Record<string, unknown>) : undefined;
  emit({
    type: "cosmetic_equipped",
    seq: num(d["seq"], lastSeq),
    userId: typeof d["userId"] === "string" ? (d["userId"] as string) : "",
    cosmeticId: typeof d["cosmeticId"] === "string" ? (d["cosmeticId"] as string) : "",
    slot: typeof d["slot"] === "string" ? (d["slot"] as string) : "",
    equipped: eq,
  } as unknown as never);
}
